import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'key-skeleton',
    standalone: true,
    imports: [
        CommonModule
    ],
    template: `<div class="skeleton" [ngStyle]="{ width: this.width(), height: this.height() }"></div>`,
    styleUrl: './skeleton.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonComponent {

    width = input<string>("100%");
    height = input<string>("1rem");

}
